// extracted by mini-css-extract-plugin
var _1 = "DeltaPreviewParagraph-module__searchHighlight--MFfAS";
export { _1 as "searchHighlight" }
